import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'

export default function CreateVersion({ onClose, show, onSubmit }) {
    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ minWidth: 358 }}>
                <BaseForm onBack={onClose} title="Create Version">
                    <div className={styles.menuDescription}>
                        <div>Are you sure you want to create a version?</div>
                    </div>
                    
                    <div className={styles.actionGroup}>
                        <Button style={{ width: '100%' }} variant="primary" onClick={onSubmit}>Yes</Button>
                        <Button style={{ width: '100%' }} variant="outline" onClick={onClose}>Cancel</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}